<script lang="ts">
  // Import the price row component
  // import PriceRow from '$components/PriceRow.svelte'

  /*
    Clinical Users: Free for life!
      - tbd

    Healthcare Facility: Price per MAU
      - tbd

    Healthcare Provider: Price per MAU
      - Rigorous credentialing
      - License verification
      - Background checks
      - Skill assessments
      - Patient matching
      - Patient-centered care plans (EHR integration - roadmap)
      - Progress notes (EHR integration - roadmap)
      - Medication records (EHR integration - roadmap)
      - Flexible scheduling
      - Quality assurance planning

    Healthcare Staffing Agency: $0.50 per shift filled
      [internal note: $10 /mo * 5k MAU = $50k /mo]
      [internal note: $0.75 /shift * 3 shifts /week * 4 weeks /mo * 5k MAU = $45k /mo]
      - Lead tracking
      - Candidate credentialing and verification
      - Background checks
      - Facility matching
      - Robust scheduling
   */
</script>

<svelte:head>
  <title>Pricing - LastMinute</title>
</svelte:head>

<div class="px-6 pt-10 lg:px-8 lg:pt-40">
  <div class="sm:align-center sm:flex sm:flex-col text-center">
    <h1 class="text-5xl font-medium text-gray-100 sm:text-center">
      <span
        class="from-pink-400 via-violet-600 to-cyan-300 bg-gradient-to-r bg-clip-text text-transparent"
      >
        Pricing plans
      </span>
      for everyone
    </h1>
    <p class="mx-auto mt-6 max-w-2xl text-center text-lg leading-8 text-gray-400">
      Until we launch our paid plans, all features are currently free. We are committed to providing
      transparent pricing that aligns with the needs of healthcare organizations. Stay tuned for
      updates on our pricing plans and how we can support your organization.
    </p>
    <!--
    <p class="mx-auto mt-6 max-w-2xl text-center text-lg leading-8 text-gray-400">
      Transparent pricing for every healthcare organization. Choose the plan that best fits your
      needs. No hidden fees, no surprises.
    </p>
    -->
    <!--
    <div class="relative mt-6 flex self-center rounded-lg bg-gray-100 p-0.5 sm:mt-8">
      <button
        type="button"
        class="relative w-1/2 whitespace-nowrap rounded-md border-gray-200 bg-white py-2 text-sm font-medium text-gray-100 shadow-sm focus:z-10 focus:outline-none focus:ring-2 focus:ring-violet-500 sm:w-auto sm:px-8"
        >Monthly billing</button
      >
      <button
        type="button"
        class="relative ml-0.5 w-1/2 whitespace-nowrap rounded-md border border-transparent py-2 text-sm font-medium text-gray-700 focus:z-10 focus:outline-none focus:ring-2 focus:ring-violet-500 sm:w-auto sm:px-8"
        >Yearly billing</button
      >
    </div>
    -->
  </div>
  <!--
  <div
    class="mt-12 space-y-4 sm:mt-16 sm:grid sm:grid-cols-2 sm:gap-6 sm:space-y-0 lg:mx-auto lg:max-w-4xl xl:mx-0 xl:max-w-none xl:grid-cols-4"
  >
    <div
      class="divide-y divide-gray-200 rounded-lg border border-gray-200 shadow-sm bg-gradient-to-b from-white to-gray-50"
    >
      <div class="p-6">
        <h2 class="text-lg font-medium leading-6 text-gray-100">Healthcare Professional</h2>
        <p class="mt-4 text-sm text-gray-500">
          Unlock endless opportunities in healthcare employment, free forever.
        </p>
        <p class="mt-8">
          <span class="text-4xl font-bold text-gray-100">$0</span>
          <span class="text-base font-medium text-gray-500">/forever</span>
        </p>
        <a
          href="https://app.trylastminute.com/register?type=professional"
          class="mt-8 block w-full rounded-md border border-transparent bg-violet-600 py-2 text-center text-sm font-semibold text-white hover:bg-violet-700"
          >Get Started</a
        >
      </div>
      <div class="px-6 pb-8 pt-6">
        <h3 class="text-sm font-medium text-gray-100">What's included</h3>
        <ul role="list" class="mt-6 space-y-4">
          <PriceRow>View your schedule</PriceRow>
          <PriceRow>Pick up extra shifts</PriceRow>
        </ul>
      </div>
    </div>
    <div
      class="divide-y divide-gray-200 rounded-lg border border-gray-200 shadow-sm bg-gradient-to-b from-white to-gray-50"
    >
      <div class="p-6">
        <h2 class="text-lg font-medium leading-6 text-gray-100">Healthcare Provider</h2>
        <p class="mt-4 text-sm text-gray-500">
          Elevate your in-home care services with our comprehensive staffing solutions.
        </p>
        <p class="mt-8">
          <span class="text-4xl font-bold text-gray-100">$8</span>
          <span class="text-base font-medium text-gray-500">/mau</span>
        </p>
        <a
          href="https://app.trylastminute.com/register?type=provider"
          class="mt-8 block w-full rounded-md border border-transparent bg-violet-600 py-2 text-center text-sm font-semibold text-white hover:bg-violet-700"
          >Get Started</a
        >
      </div>
      <div class="px-6 pb-8 pt-6">
        <h3 class="text-sm font-medium text-gray-100">What's included</h3>
        <ul role="list" class="mt-6 space-y-4">
          <PriceRow>Potenti felis, in cras at at ligula nunc.</PriceRow>
          <PriceRow>Orci neque eget pellentesque.</PriceRow>
          <PriceRow>Donec mauris sit in eu tincidunt etiam.</PriceRow>
        </ul>
      </div>
    </div>
    <div
      class="divide-y divide-gray-200 rounded-lg border border-gray-200 shadow-sm bg-gradient-to-b from-white to-gray-50"
    >
      <div class="p-6">
        <h2 class="text-lg font-medium leading-6 text-gray-100">Healthcare Facility</h2>
        <p class="mt-4 text-sm text-gray-500">
          Achieve optimal staffing efficiency and compliance in your healthcare operations.
        </p>
        <p class="mt-8">
          <span class="text-4xl font-bold text-gray-100">$10</span>
          <span class="text-base font-medium text-gray-500">/mau</span>
        </p>
        <a
          href="https://app.trylastminute.com/register?type=facility"
          class="mt-8 block w-full rounded-md border border-transparent bg-violet-600 py-2 text-center text-sm font-semibold text-white hover:bg-violet-700"
          >Get Started</a
        >
      </div>
      <div class="px-6 pb-8 pt-6">
        <h3 class="text-sm font-medium text-gray-100">What's included</h3>
        <ul role="list" class="mt-6 space-y-4">
          <PriceRow>Potenti felis, in cras at at ligula nunc.</PriceRow>
          <PriceRow>Orci neque eget pellentesque.</PriceRow>
          <PriceRow>Donec mauris sit in eu tincidunt etiam.</PriceRow>
          <PriceRow>Faucibus volutpat magna.</PriceRow>
        </ul>
      </div>
    </div>
    <div
      class="divide-y divide-gray-200 rounded-lg border border-gray-200 shadow-sm bg-gradient-to-b from-white to-gray-50"
    >
      <div class="p-6">
        <h2 class="text-lg font-medium leading-6 text-gray-100">Staffing Agency</h2>
        <p class="mt-4 text-sm text-gray-500">
          Facilitate seamless staffing connections with precision and ease.
        </p>
        <p class="mt-8">
          <span class="text-4xl font-bold text-gray-100">$0.75</span>
          <span class="text-base font-medium text-gray-500">/filled shift</span>
        </p>
        <a
          href="https://app.trylastminute.com/register?type=agency"
          class="mt-8 block w-full rounded-md border border-transparent bg-violet-600 py-2 text-center text-sm font-semibold text-white hover:bg-violet-700"
          >Get Started</a
        >
      </div>
      <div class="px-6 pb-8 pt-6">
        <h3 class="text-sm font-medium text-gray-100">What's included</h3>
        <ul role="list" class="mt-6 space-y-4">
          <PriceRow>Potenti felis, in cras at at ligula nunc.</PriceRow>
          <PriceRow>Orci neque eget pellentesque.</PriceRow>
          <PriceRow>Donec mauris sit in eu tincidunt etiam.</PriceRow>
          <PriceRow>Faucibus volutpat magna.</PriceRow>
          <PriceRow>Id sed tellus in varius quisque.</PriceRow>
          <PriceRow>Risus egestas faucibus.</PriceRow>
          <PriceRow>Risus cursus ullamcorper.</PriceRow>
        </ul>
      </div>
    </div>
  </div>
  -->
</div>

<div>
  <div class="mx-auto max-w-5xl px-6 py-16 sm:py-24 lg:px-8">
    <div class="mx-auto max-w-2xl text-center">
      <h2 class="text-2xl font-medium leading-10 text-gray-100">Frequently asked questions</h2>
      <p class="mt-6 text-base leading-7 text-gray-400">
        Have a different question and can’t find the answer you’re looking for? Reach out to our
        support team by <a
          href="mailto:support@trylastminute.com"
          class="font-semibold text-violet-400 hover:text-violet-300 underline"
        >
          sending us an email
        </a> and we’ll get back to you as soon as we can.
      </p>
    </div>
    <div class="mt-20">
      <dl class="space-y-8 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:gap-x-5">
        <div>
          <dt class="text-base font-semibold leading-7 text-gray-100">
            What does MAU stand for in your pricing?
          </dt>
          <dd class="mt-2 text-base leading-7 text-gray-400">
            MAU stands for Monthly Active User, which refers to a unique user who has engaged with
            our platform within a calendar month. This metric helps us tailor our services and
            pricing to the actual usage and needs of your organization.
          </dd>
        </div>
        <div>
          <dt class="text-base font-semibold leading-7 text-gray-100">
            How do you define a 'filled shift' for staffing agencies?
          </dt>
          <dd class="mt-2 text-base leading-7 text-gray-400">
            A filled shift refers to any shift that is successfully staffed through our platform,
            where a healthcare professional is matched and confirmed to work at a healthcare
            facility or for a healthcare provider.
          </dd>
        </div>
        <div>
          <dt class="text-base font-semibold leading-7 text-gray-100">
            Is there a minimum commitment for any of the pricing plans?
          </dt>
          <dd class="mt-2 text-base leading-7 text-gray-400">
            No, we do not require a minimum commitment. Our plans are designed to provide maximum
            flexibility, allowing you to scale up or down based on your needs without any long-term
            contracts.
          </dd>
        </div>
        <div>
          <dt class="text-base font-semibold leading-7 text-gray-100">
            Can healthcare professionals access all features of the platform for free?
          </dt>
          <dd class="mt-2 text-base leading-7 text-gray-400">
            Yes, healthcare professionals can access all current features of the platform for free,
            including job matching, scheduling, and compliance verification, to support their career
            growth in the healthcare industry.
          </dd>
        </div>
        <div>
          <dt class="text-base font-semibold leading-7 text-gray-100">
            Do you offer discounts for non-profits or educational institutions within the healthcare
            sector?
          </dt>
          <dd class="mt-2 text-base leading-7 text-gray-400">
            We are committed to supporting the healthcare community broadly, including non-profits
            and educational institutions. Please contact us directly to discuss potential discounts
            and how we can best serve your organization.
          </dd>
        </div>
        <div>
          <dt class="text-base font-semibold leading-7 text-gray-100">
            What happens if we exceed our expected number of MAUs?
          </dt>
          <dd class="mt-2 text-base leading-7 text-gray-400">
            Our platform is designed to flexibly accommodate fluctuations in your staffing needs. If
            you consistently exceed your expected number of MAUs, we recommend contacting us to
            discuss adjusting your plan to better suit your usage and optimize your costs.
          </dd>
        </div>
      </dl>
    </div>
  </div>
</div>

<div>
  <div class="mx-auto max-w-7xl py-12 sm:px-6 sm:py-24 lg:px-8">
    <div
      class="relative isolate overflow-hidden bg-gray-900 px-6 py-24 text-center shadow-2xl sm:rounded-3xl sm:px-16"
    >
      <h2 class="mx-auto max-w-2xl text-3xl font-bold tracking-tight text-white sm:text-4xl">
        Stay ahead of compliance
      </h2>
      <p class="mx-auto mt-6 max-w-xl text-lg leading-8 text-gray-300">
        Navigate healthcare regulations confidently with our platform, ensuring your staffing
        remains compliant through real-time updates and comprehensive compliance tracking.
      </p>
      <div class="mt-10 flex items-center justify-center gap-x-6">
        <a
          href="https://app.trylastminute.com"
          class="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
        >
          Get started
        </a>
        <a href="/features" class="text-sm font-semibold leading-6 text-white">
          Learn more <span aria-hidden="true">→</span>
        </a>
      </div>
      <svg
        viewBox="0 0 1024 1024"
        class="absolute left-1/2 top-1/2 -z-10 h-[64rem] w-[64rem] -translate-x-1/2 [mask-image:radial-gradient(closest-side,white,transparent)]"
        aria-hidden="true"
      >
        <circle
          cx="512"
          cy="512"
          r="512"
          fill="url(#827591b1-ce8c-4110-b064-7cb85a0b1217)"
          fill-opacity="0.7"
        />
        <defs>
          <radialGradient id="827591b1-ce8c-4110-b064-7cb85a0b1217">
            <stop stop-color="#7775D6" />
            <stop offset="1" stop-color="#E935C1" />
          </radialGradient>
        </defs>
      </svg>
    </div>
  </div>
</div>
